import {
  fetchToken,
  iterateTree,
  MapServerLayer,
  useMapLayerSetting,
} from '@agissc/ktag-map';
import useAppState from '../../../AppStore';
import { MapLayerSetting, SubLayerProps } from './Contracts';

const updateSubLayers = (
  data: Record<number, MapServerLayer>,
  subLayerSetting: SubLayerProps[] = [],
) => {
  const getSettingProperty = (id: number, property: 'isEnabled' | 'isExpanded') =>
    subLayerSetting.find((l) => l.id === id)?.[property] ?? false;

  const nodes: Record<number, MapLayerSetting> = {};

  Object.entries(data).forEach(([, item], index) => {
    const isEnabled = subLayerSetting.length
      ? getSettingProperty(item.id, 'isEnabled')
      : item.defaultVisibility;

    nodes[item.id] = {
      id: item.id,
      name: item.name,
      parentLayerId: item.parentLayerId,
      subLayerIds: item.subLayerIds ?? [],
      minScale: item.minScale,
      maxScale: item.maxScale,
      isGroupLayer: (item.subLayerIds?.length ?? 0) >= 1,
      isRoot: item.parentLayerId === -1,
      isEnabled,
      isVisible: isEnabled,
      isExpanded: getSettingProperty(item.id, 'isExpanded'),
      order: index,
    };
  });

  iterateTree<MapLayerSetting>(
    nodes,
    (node) => {
      nodes[node.id].isVisible =
        node.isVisible && (node.isRoot || nodes[node.parentLayerId].isVisible);
    },
    (node) => node.isRoot,
    (node) =>
      Object.values(nodes)
        .filter((n) => n.parentLayerId === node.id)
        .map((n) => n.id),
  );

  return nodes;
};

const useSubLayersSetting = (
  topicId: string,
  topicLayerUrl: string,
  isPublic: boolean,
) => {
  const topicSubLayerSetting = useAppState((state) => state.topicSubLayerSetting);

  return useMapLayerSetting(
    topicLayerUrl,
    isPublic ? undefined : fetchToken,
    (fetchedData) => updateSubLayers(fetchedData, topicSubLayerSetting[topicId]),
  );
};

export default useSubLayersSetting;
